
// import React, { useEffect, useState, useMemo } from "react";
// import {
//   Row,
//   Col,
//   Card,
//   Select,
//   DatePicker,
//   Input,
//   Spin,
//   Typography,
//   Divider,
//   Modal,
//   Button,
//   Empty,
//   Tag,
//   Space,
// } from "antd";
// import dayjs from "dayjs";
// import { TLSApi } from "./Tls_ApiService";
// import {
//   SearchOutlined,
//   CalendarOutlined,
//   UserOutlined,
//   BarcodeOutlined,
//   ClockCircleOutlined,
//   HighlightOutlined // Using HighlightOutlined instead of PaletteOutlined
// } from "@ant-design/icons";
// import "dayjs/locale/en";

// const { Title, Text } = Typography;
// const { Option } = Select;

// // Modern color palette
// const colors = {
//   primary: "#2563eb",
//   primaryLight: "#3b82f6",
//   secondary: "#64748b",
//   success: "#10b981",
//   danger: "#ef4444",
//   warning: "#f59e0b",
//   background: "#f8fafc",
//   surface: "#ffffff",
//   text: "#1e293b",
//   textLight: "#64748b",
//   border: "#e2e8f0",
// };

// export default function TLSPage() {
//   const [lines, setLines] = useState([]);
//   const [items, setItems] = useState([]);
//   const [timeSettings, setTimeSettings] = useState([]);

//   const [selectedLine, setSelectedLine] = useState("");
//   const [selectedItem, setSelectedItem] = useState("");
//   const [selectedDate, setSelectedDate] = useState(dayjs()); // today by default

//   const [color, setColor] = useState("N/A");
//   const [styleNo, setStyleNo] = useState("N/A");
//   const [currentTimeId, setCurrentTimeId] = useState("");

//   const [tableData, setTableData] = useState([]);
//   const [filteredTableData, setFilteredTableData] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const [searchQuery, setSearchQuery] = useState("");

//   const [defectModal, setDefectModal] = useState({
//     visible: false,
//     title: "",
//     defects: [],
//   });

//   // Load su_id
//   const suId = useMemo(() => {
//     try {
//       const stored = JSON.parse(localStorage.getItem("userData"));
//       return stored?.data?.su_id ?? "";
//     } catch {
//       return "";
//     }
//   }, []);

//   // initial load: lines and time settings
//   useEffect(() => {
//     loadLines();
//     loadTimeSettings();
//   }, []);

//   // Load data when component mounts with today's date
//   useEffect(() => {
//     if (selectedLine && selectedItem && selectedDate) {
//       const payloadDate = selectedDate.format("YYYY-MM-DD");
//       loadTlsBoard(selectedLine, selectedItem, payloadDate);
//     }
//   }, [selectedLine, selectedItem, selectedDate]);

//   async function loadLines() {
//     try {
//       setLoading(true);
//       const res = await TLSApi.getTlsLines(suId);
//       if (res?.data?.status) {
//         setLines(res.data.data.lines || []);
//       } else {
//         setLines([]);
//       }
//     } catch (err) {
//       console.error("loadLines err", err);
//       setLines([]);
//     } finally {
//       setLoading(false);
//     }
//   }

//   async function loadTimeSettings() {
//     try {
//       const res = await TLSApi.getTlsTimeSettings();
//       if (res?.data?.status) {
//         setTimeSettings(res.data.data || []);
//       } else {
//         setTimeSettings([]);
//       }
//     } catch (err) {
//       console.error("loadTimeSettings", err);
//       setTimeSettings([]);
//     }
//   }

//   // When line changes -> load items, reset other state
//   async function onLineChange(line) {
//     setSelectedLine(line);
//     setSelectedItem("");
//     setColor("N/A");
//     setStyleNo("N/A");
//     setTableData([]);
//     setFilteredTableData([]);
//     if (!line) {
//       setItems([]);
//       return;
//     }
//     try {
//       setLoading(true);
//       const res = await TLSApi.getItemsByLine(line);
//       if (res?.data?.status) {
//         const itemsFromApi = res.data.data?.items || [];
//         const normalized =
//           itemsFromApi.map((it) =>
//             typeof it === "string" ? { item_no: it, batch_status: "" } : it
//           ) || [];
//         setItems(normalized);
//       } else {
//         setItems([]);
//       }
//     } catch (err) {
//       console.error("getItemsByLine", err);
//       setItems([]);
//     } finally {
//       setLoading(false);
//     }
//   }

//   // When item changes -> fetch color/style
//   async function onItemChange(itemNo) {
//     setSelectedItem(itemNo);
//     setColor("N/A");
//     setStyleNo("N/A");
//     setTableData([]);
//     setFilteredTableData([]);
//     if (!itemNo || !selectedLine) return;
//     try {
//       setLoading(true);
//       const res = await TLSApi.getColorStyle(selectedLine, itemNo);
//       if (res?.data?.status && Array.isArray(res.data.data) && res.data.data.length) {
//         const first = res.data.data[0];
//         setColor(first.colour ?? "N/A");
//         setStyleNo(first.style_no ?? "N/A");
//       } else {
//         setColor("N/A");
//         setStyleNo("N/A");
//       }
//     } catch (err) {
//       console.error("getColorStyle", err);
//       setColor("N/A");
//       setStyleNo("N/A");
//     } finally {
//       setLoading(false);
//     }
//   }

//   // When date selected
//   async function onDateChange(date) {
//     setSelectedDate(date);
//     setTableData([]);
//     setFilteredTableData([]);
//   }

//   async function loadTlsBoard(lineNo, itemNo, dateString) {
//     try {
//       setLoading(true);
//       const res = await TLSApi.getTlsBoardReport(lineNo, itemNo, dateString);
//       if (res?.data?.status) {
//         const d = res.data;
//         setCurrentTimeId(d.time_id ?? "");

//         const rows = (d.batch_details || []).map((item, idx) => {
//           const qcData = Array.isArray(item.qc_data) ? item.qc_data : [];
//           const timeStatuses = {};
          
//           (timeSettings || []).forEach((t) => {
//             const qcForHour = qcData.find((q) => q.hour === t.time_id) || null;
//             timeStatuses[t.time_id] = qcForHour
//               ? {
//                   status: qcForHour.tls_status ?? "",
//                   defects: qcForHour.defects ?? [],
//                   tot_defects: qcForHour.tot_defects ?? "",
//                 }
//               : {};
//           });

//           return {
//             no: idx + 1,
//             tls_op_name: item.tls_operation?.tls_op_name ?? "",
//             staff_user: {
//               full_name: item.staff_user?.full_name ?? "",
//               username: item.staff_user?.username ?? "",
//             },
//             timeStatuses,
//             start_time: item.start_time || "",
//             hasQcData: qcData.length > 0,
//             batch_id: item.batch_id ?? "",
//           };
//         });

//         setTableData(rows);
//         setFilteredTableData(rows);
//       } else {
//         setTableData([]);
//         setFilteredTableData([]);
//       }
//     } catch (err) {
//       console.error("loadTlsBoard", err);
//       setTableData([]);
//       setFilteredTableData([]);
//     } finally {
//       setLoading(false);
//     }
//   }

//   // Search filter
//   useEffect(() => {
//     if (!searchQuery) {
//       setFilteredTableData(tableData);
//       return;
//     }
//     const q = searchQuery.toLowerCase();
//     const filtered = tableData.filter((r) => {
//       const op = `${r.staff_user?.full_name || ""} ${r.staff_user?.username || ""}`.toLowerCase();
//       const opName = (r.tls_op_name || "").toLowerCase();
//       return op.includes(q) || opName.includes(q);
//     });
//     setFilteredTableData(filtered);
//   }, [searchQuery, tableData]);

//   // Build table header times
//   const timeHeaders = useMemo(() => 
//     timeSettings.map((t) => ({ 
//       id: t.time_id, 
//       label: t.time_id,
//       timeRange: `${(t.start_time||"").slice(0,5)}-${(t.end_time||"").slice(0,5)}`
//     })), 
//     [timeSettings]
//   );

//   // Status color mapping
//   const statusToColor = (status) => {
//     if (!status) return colors.success; // green default
//     if (status === "yellow") return colors.warning;
//     if (status === "red") return colors.danger;
//     if (status === "blue") return colors.primary;
//     if (status === "green") return colors.success;
//     return colors.primary;
//   };

//   const openDefectModal = (title, defects) => {
//     setDefectModal({ visible: true, title, defects: defects || [] });
//   };
//   const closeDefectModal = () => setDefectModal({ visible: false, title: "", defects: [] });

//   // Custom styles
//   const containerStyle = {
//     background: colors.background,
//     minHeight: "100vh",
//     padding: "24px",
//   };

//   const cardStyle = {
//     background: colors.surface,
//     borderRadius: "12px",
//     padding: "24px",
//     boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
//     border: `1px solid ${colors.border}`,
//   };

//   const infoCardStyle = {
//     background: `linear-gradient(135deg, ${colors.primary}08, ${colors.primary}03)`,
//     border: `1px solid ${colors.primary}15`,
//     borderRadius: "8px",
//     padding: "16px",
//   };

//   const thStyle = {
//     padding: "16px 12px",
//     textAlign: "center",
//     background: colors.background,
//     color: colors.text,
//     fontWeight: "600",
//     fontSize: "13px",
//     borderBottom: `2px solid ${colors.border}`,
//     whiteSpace: "nowrap",
//     minWidth: "120px",
//   };

//   const tdStyle = {
//     padding: "16px 12px",
//     borderBottom: `1px solid ${colors.border}`,
//     color: colors.text,
//     fontSize: "14px",
//   };

//   const tdStyleCenter = { 
//     ...tdStyle, 
//     textAlign: "center",
//     minWidth: "120px",
//   };

//   return (
//     <div style={containerStyle}>
//       <div style={cardStyle}>
//         {/* Header Section */}
//         <div style={{ marginBottom: "32px" }}>
//           <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "8px" }}>
//             <div style={{
//               width: "4px",
//               height: "32px",
//               background: colors.primary,
//               borderRadius: "2px"
//             }}></div>
//             <Title level={2} style={{ margin: 0, color: colors.text }}>
//               TLS Board
//             </Title>
//           </div>
//           <Text style={{ color: colors.textLight, fontSize: "16px" }}>
//             Track operator performance and quality status across time slots
//           </Text>
//         </div>

//         {/* Filters Section */}
//         <Card 
//           style={{ 
//             ...cardStyle, 
//             marginBottom: "20px",
//             background: `linear-gradient(135deg, ${colors.primary}02, ${colors.primary}05)`
//           }}
//           bodyStyle={{ padding: "20px" }}
//         >
//           <Row gutter={[20, 16]}>
//             <Col xs={24} md={8}>
//               <Text strong style={{ display: "block", marginBottom: "8px", color: colors.text }}>
//                 <UserOutlined style={{ marginRight: "8px", color: colors.primary }} />
//                 Production Line
//               </Text>
//               <Select
//                 placeholder="Select Line"
//                 value={selectedLine || undefined}
//                 onChange={onLineChange}
//                 allowClear
//                 style={{ width: "100%" }}
//                 loading={loading && !lines.length}
//                 size="large"
//                 suffixIcon={<UserOutlined style={{ color: colors.primary }} />}
//               >
//                 {lines.map((l, idx) => (
//                   <Option key={idx} value={l}>
//                     {l}
//                   </Option>
//                 ))}
//               </Select>
//             </Col>

//             <Col xs={24} md={8}>
//               <Text strong style={{ display: "block", marginBottom: "8px", color: colors.text }}>
//                 <BarcodeOutlined style={{ marginRight: "8px", color: colors.primary }} />
//                 Item Number
//               </Text>
//               <Select
//                 placeholder="Select Item"
//                 value={selectedItem || undefined}
//                 onChange={onItemChange}
//                 allowClear
//                 style={{ width: "100%" }}
//                 disabled={!selectedLine}
//                 size="large"
//                 suffixIcon={<BarcodeOutlined style={{ color: colors.primary }} />}
//               >
//                 {items.map((it, idx) => (
//                   <Option key={idx} value={it.item_no}>
//                     {it.item_no} {it.batch_status ? `(${it.batch_status})` : ""}
//                   </Option>
//                 ))}
//               </Select>
//             </Col>

//             <Col xs={24} md={8}>
//               <Text strong style={{ display: "block", marginBottom: "8px", color: colors.text }}>
//                 <CalendarOutlined style={{ marginRight: "8px", color: colors.primary }} />
//                 Select Date
//               </Text>
//               <DatePicker
//                 style={{ width: "100%" }}
//                 format="DD-MM-YYYY"
//                 value={selectedDate}
//                 onChange={onDateChange}
//                 disabled={!selectedItem}
//                 allowClear={false}
//                 size="large"
//                 suffixIcon={<CalendarOutlined style={{ color: colors.primary }} />}
//               />
//             </Col>
//           </Row>
//         </Card>

//         {/* Information Cards */}
//         {(selectedLine && selectedItem) && (
//           <div style={{ ...infoCardStyle, marginBottom: "20px" }}>
//             <Row gutter={[20, 16]} align="middle">
//               <Col xs={24} sm={6}>
//                 <div style={{ textAlign: "center" }}>
//                   <div style={{ fontSize: "12px", color: colors.textLight, fontWeight: "600", marginBottom: "4px" }}>
//                     <ClockCircleOutlined style={{ marginRight: "4px" }} />
//                     CURRENT HOUR
//                   </div>
//                   <div style={{ 
//                     fontSize: "18px", 
//                     color: colors.primary, 
//                     fontWeight: "700",
//                     background: `${colors.primary}10`,
//                     padding: "8px 12px",
//                     borderRadius: "6px"
//                   }}>
//                     {currentTimeId || "-"}
//                   </div>
//                 </div>
//               </Col>
//               <Col xs={24} sm={6}>
//                 <div style={{ textAlign: "center" }}>
//                   <div style={{ fontSize: "12px", color: colors.textLight, fontWeight: "600", marginBottom: "4px" }}>
//                     <CalendarOutlined style={{ marginRight: "4px" }} />
//                     SELECTED DATE
//                   </div>
//                   <div style={{ 
//                     fontSize: "18px", 
//                     color: colors.text, 
//                     fontWeight: "700",
//                     background: `${colors.success}10`,
//                     padding: "8px 12px",
//                     borderRadius: "6px"
//                   }}>
//                     {selectedDate ? selectedDate.format("DD/MM/YYYY") : "-"}
//                   </div>
//                 </div>
//               </Col>
//               <Col xs={24} sm={6}>
//                 <div style={{ textAlign: "center" }}>
//                   <div style={{ fontSize: "12px", color: colors.textLight, fontWeight: "600", marginBottom: "4px" }}>
//                     <HighlightOutlined style={{ marginRight: "4px" }} />
//                     COLOR
//                   </div>
//                   <div style={{ 
//                     fontSize: "18px", 
//                     color: colors.text, 
//                     fontWeight: "700",
//                     background: `${colors.warning}10`,
//                     padding: "8px 12px",
//                     borderRadius: "6px"
//                   }}>
//                     {color}
//                   </div>
//                 </div>
//               </Col>
//               <Col xs={24} sm={6}>
//                 <div style={{ textAlign: "center" }}>
//                   <div style={{ fontSize: "12px", color: colors.textLight, fontWeight: "600", marginBottom: "4px" }}>
//                     <BarcodeOutlined style={{ marginRight: "4px" }} />
//                     STYLE NUMBER
//                   </div>
//                   <div style={{ 
//                     fontSize: "18px", 
//                     color: colors.text, 
//                     fontWeight: "700",
//                     background: `${colors.secondary}10`,
//                     padding: "8px 12px",
//                     borderRadius: "6px"
//                   }}>
//                     {styleNo}
//                   </div>
//                 </div>
//               </Col>
//             </Row>
//           </div>
//         )}

//         {/* Search and Table Section */}
//         <Card style={cardStyle} bodyStyle={{ padding: 0 }}>
//           {/* Search Header */}
//           <div style={{ 
//             padding: "20px 24px", 
//             borderBottom: `1px solid ${colors.border}`,
//             display: "flex", 
//             justifyContent: "space-between", 
//             alignItems: "center",
//             background: colors.background
//           }}>
//             <Text strong style={{ fontSize: "16px", color: colors.text }}>
//               Operator Performance Data
//             </Text>
//             <Input
//               placeholder="Search operator or operation..."
//               prefix={<SearchOutlined style={{ color: colors.textLight }} />}
//               value={searchQuery}
//               onChange={(e) => setSearchQuery(e.target.value)}
//               style={{ width: 300 }}
//               allowClear
//             />
//           </div>

//           {/* Table with Horizontal Scroll */}
//           <Spin spinning={loading} size="large">
//             {!filteredTableData.length ? (
//               <div style={{ padding: "60px 20px" }}>
//                 <Empty 
//                   description={
//                     selectedDate ? "No operator data for selected filters" : "Select Line, Item and Date to load data"
//                   }
//                   imageStyle={{ height: 80 }}
//                 />
//               </div>
//             ) : (
//               <div style={{ 
//                 overflowX: "auto",
//                 width: "100%"
//               }}>
//                 <table style={{ 
//                   width: "100%", 
//                   borderCollapse: "collapse",
//                   minWidth: "800px"
//                 }}>
//                   <thead>
//                     <tr>
//                       <th style={{ ...thStyle, width: "60px", minWidth: "60px" }}>#</th>
//                       <th style={{ ...thStyle, textAlign: "left", width: "200px", minWidth: "200px" }}>Operator</th>
//                       <th style={{ ...thStyle, textAlign: "left", width: "250px", minWidth: "250px" }}>Operation Name</th>
//                       {timeHeaders.map((t) => (
//                         <th key={t.id} style={thStyle}>
//                           <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
//                             <Text strong style={{ fontSize: "14px", color: colors.primary }}>
//                               {t.label}
//                             </Text>
//                             <Text style={{ fontSize: "11px", color: colors.textLight, marginTop: "2px" }}>
//                               {t.timeRange}
//                             </Text>
//                           </div>
//                         </th>
//                       ))}
//                     </tr>
//                   </thead>

//                   <tbody>
//                     {filteredTableData.map((row, idx) => (
//                       <tr key={idx} style={{ 
//                         borderBottom: `1px solid ${colors.border}`,
//                         background: idx % 2 === 0 ? colors.surface : `${colors.background}50`,
//                         transition: "background 0.2s ease",
//                       }}>
//                         <td style={{ ...tdStyleCenter, width: "60px" }}>{row.no}</td>
//                         <td style={{ ...tdStyle, width: "200px" }}>
//                           <div>
//                             <Text strong style={{ display: "block", color: colors.text }}>
//                               {row.staff_user?.full_name}
//                             </Text>
//                             <Text type="secondary" style={{ fontSize: "12px" }}>
//                               {row.staff_user?.username}
//                             </Text>
//                           </div>
//                         </td>
//                         <td style={{ ...tdStyle, width: "250px" }}>
//                           <Text style={{ color: colors.text }}>
//                             {row.tls_op_name}
//                           </Text>
//                         </td>

//                         {timeHeaders.map((t) => {
//                           const ts = row.timeStatuses?.[t.id] || {};
//                           const empty = !ts || Object.keys(ts).length === 0;
//                           if (empty) return <td key={t.id} style={tdStyleCenter}></td>;

//                           const color = statusToColor(ts.status);
//                           const hasDefects = Array.isArray(ts.defects) && ts.defects.length > 0;

//                           return (
//                             <td key={t.id} style={tdStyleCenter}>
//                               <div
//                                 role="button"
//                                 onClick={() => {
//                                   if (hasDefects) {
//                                     openDefectModal(
//                                       `Defects - ${row.staff_user?.full_name} - ${t.id} (${t.timeRange})`, 
//                                       ts.defects
//                                     );
//                                   }
//                                 }}
//                                 style={{
//                                   width: "36px",
//                                   height: "36px",
//                                   margin: "auto",
//                                   borderRadius: "50%",
//                                   background: color,
//                                   display: "flex",
//                                   alignItems: "center",
//                                   justifyContent: "center",
//                                   cursor: hasDefects ? "pointer" : "default",
//                                   border: `2px solid ${colors.border}`,
//                                   boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
//                                   transition: "all 0.2s ease",
//                                   transform: hasDefects ? "scale(1)" : "scale(0.9)",
//                                 }}
//                                 onMouseEnter={(e) => {
//                                   if (hasDefects) {
//                                     e.target.style.transform = "scale(1.1)";
//                                     e.target.style.boxShadow = "0 4px 8px rgba(0,0,0,0.2)";
//                                   }
//                                 }}
//                                 onMouseLeave={(e) => {
//                                   if (hasDefects) {
//                                     e.target.style.transform = "scale(1)";
//                                     e.target.style.boxShadow = "0 2px 4px rgba(0,0,0,0.1)";
//                                   }
//                                 }}
//                                 title={hasDefects ? `View defects (Total: ${ts.tot_defects})` : "No defects"}
//                               >
//                                 <div style={{ 
//                                   width: "16px", 
//                                   height: "16px", 
//                                   borderRadius: "50%", 
//                                   background: "#fff",
//                                   boxShadow: "0 1px 2px rgba(0,0,0,0.1)"
//                                 }} />
//                               </div>
//                             </td>
//                           );
//                         })}
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             )}
//           </Spin>
//         </Card>
//       </div>

//       {/* Defect Details Modal */}
//       <Modal
//         open={defectModal.visible}
//         title={
//           <div>
//             <Text strong style={{ color: colors.primary, fontSize: "16px" }}>
//               {defectModal.title}
//             </Text>
//           </div>
//         }
//         onCancel={closeDefectModal}
//         footer={[
//           <Button 
//             key="close" 
//             onClick={closeDefectModal}
//             type="primary"
//             style={{ background: colors.primary, borderColor: colors.primary }}
//           >
//             Close
//           </Button>,
//         ]}
//         width={600}
//       >
//         {Array.isArray(defectModal.defects) && defectModal.defects.length ? (
//           <div style={{ maxHeight: "400px", overflowY: "auto" }}>
//             {defectModal.defects.map((d, i) => (
//               <Card 
//                 key={i} 
//                 size="small" 
//                 style={{ 
//                   marginBottom: "12px",
//                   border: `1px solid ${colors.border}`,
//                   background: `${colors.background}50`
//                 }}
//                 bodyStyle={{ padding: "16px" }}
//               >
//                 <Space direction="vertical" style={{ width: "100%" }} size="small">
//                   <div>
//                     <Text strong style={{ color: colors.text }}>Defect Reason: </Text>
//                     <Text style={{ color: colors.text }}>{d.reason || "Not specified"}</Text>
//                   </div>
//                   <Divider style={{ margin: "8px 0", background: colors.border }} />
//                   <div>
//                     <Text type="secondary">Defect Code: </Text>
//                     <Tag color={colors.primary} style={{ marginLeft: "8px" }}>
//                       {d.def_code || "N/A"}
//                     </Tag>
//                   </div>
//                 </Space>
//               </Card>
//             ))}
//           </div>
//         ) : (
//           <Empty description="No defects recorded for this time slot" />
//         )}
//       </Modal>
//     </div>
//   );
// }
// src/pages/Smart_TLS/TLS_Board.js
import React, { useEffect, useState, useMemo } from "react";
import {
  Row,
  Col,
  Card,
  Select,
  DatePicker,
  Input,
  Spin,
  Typography,
  Divider,
  Modal,
  Button,
  Empty,
  Tag,
  Space,
} from "antd";
import dayjs from "dayjs";
import { TLSApi } from "./Tls_ApiService";
import {
  SearchOutlined,
  CalendarOutlined,
  UserOutlined,
  BarcodeOutlined,
  ClockCircleOutlined,
  HighlightOutlined
} from "@ant-design/icons";
import "dayjs/locale/en";

const { Title, Text } = Typography;
const { Option } = Select;

// Modern color palette
const colors = {
  primary: "#2563eb",
  primaryLight: "#3b82f6",
  secondary: "#64748b",
  success: "#10b981",
  danger: "#ef4444",
  warning: "#f59e0b",
  background: "#f8fafc",
  surface: "#ffffff",
  text: "#1e293b",
  textLight: "#64748b",
  border: "#e2e8f0",
};

export default function TLSPage() {
  const [lines, setLines] = useState([]);
  const [items, setItems] = useState([]);
  const [timeSettings, setTimeSettings] = useState([]);

  const [selectedLine, setSelectedLine] = useState("");
  const [selectedItem, setSelectedItem] = useState("");
  const [selectedDate, setSelectedDate] = useState(dayjs()); // today by default

  const [color, setColor] = useState("N/A");
  const [styleNo, setStyleNo] = useState("N/A");
  const [currentTimeId, setCurrentTimeId] = useState("");

  const [tableData, setTableData] = useState([]);
  const [filteredTableData, setFilteredTableData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");

  const [defectModal, setDefectModal] = useState({
    visible: false,
    title: "",
    defects: [],
  });

  // Load su_id
  const suId = useMemo(() => {
    try {
      const stored = JSON.parse(localStorage.getItem("userData"));
      return stored?.data?.su_id ?? "";
    } catch {
      return "";
    }
  }, []);

  // initial load: lines and time settings
  useEffect(() => {
    loadLines();
    loadTimeSettings();
  }, []);

  // Load data when component mounts with today's date and when dependencies change
  useEffect(() => {
    if (selectedLine && selectedItem && selectedDate && timeSettings.length > 0) {
      const payloadDate = selectedDate.format("YYYY-MM-DD");
      loadTlsBoard(selectedLine, selectedItem, payloadDate);
    }
  }, [selectedLine, selectedItem, selectedDate, timeSettings]);

  async function loadLines() {
    try {
      setLoading(true);
      const res = await TLSApi.getTlsLines(suId);
      if (res?.data?.status) {
        setLines(res.data.data.lines || []);
      } else {
        setLines([]);
      }
    } catch (err) {
      console.error("loadLines err", err);
      setLines([]);
    } finally {
      setLoading(false);
    }
  }

  async function loadTimeSettings() {
    try {
      const res = await TLSApi.getTlsTimeSettings();
      if (res?.data?.status) {
        setTimeSettings(res.data.data || []);
      } else {
        setTimeSettings([]);
      }
    } catch (err) {
      console.error("loadTimeSettings", err);
      setTimeSettings([]);
    }
  }

  // When line changes -> load items, reset other state
  async function onLineChange(line) {
    setSelectedLine(line);
    setSelectedItem("");
    setColor("N/A");
    setStyleNo("N/A");
    setTableData([]);
    setFilteredTableData([]);
    if (!line) {
      setItems([]);
      return;
    }
    try {
      setLoading(true);
      const res = await TLSApi.getItemsByLine(line);
      if (res?.data?.status) {
        const itemsFromApi = res.data.data?.items || [];
        const normalized =
          itemsFromApi.map((it) =>
            typeof it === "string" ? { item_no: it, batch_status: "" } : it
          ) || [];
        setItems(normalized);
      } else {
        setItems([]);
      }
    } catch (err) {
      console.error("getItemsByLine", err);
      setItems([]);
    } finally {
      setLoading(false);
    }
  }

  // When item changes -> fetch color/style
  async function onItemChange(itemNo) {
    setSelectedItem(itemNo);
    setColor("N/A");
    setStyleNo("N/A");
    setTableData([]);
    setFilteredTableData([]);
    if (!itemNo || !selectedLine) return;
    try {
      setLoading(true);
      const res = await TLSApi.getColorStyle(selectedLine, itemNo);
      if (res?.data?.status && Array.isArray(res.data.data) && res.data.data.length) {
        const first = res.data.data[0];
        setColor(first.colour ?? "N/A");
        setStyleNo(first.style_no ?? "N/A");
      } else {
        setColor("N/A");
        setStyleNo("N/A");
      }
    } catch (err) {
      console.error("getColorStyle", err);
      setColor("N/A");
      setStyleNo("N/A");
    } finally {
      setLoading(false);
    }
  }

  // When date selected
  async function onDateChange(date) {
    setSelectedDate(date);
    setTableData([]);
    setFilteredTableData([]);
  }

  async function loadTlsBoard(lineNo, itemNo, dateString) {
    try {
      setLoading(true);
      const res = await TLSApi.getTlsBoardReport(lineNo, itemNo, dateString);
      if (res?.data?.status) {
        const d = res.data;
        setCurrentTimeId(d.time_id ?? "");

        const rows = (d.batch_details || []).map((item, idx) => {
          const qcData = Array.isArray(item.qc_data) ? item.qc_data : [];
          const timeStatuses = {};
          
          // Process time slots based on timeSettings
          (timeSettings || []).forEach((t) => {
            const qcForHour = qcData.find((q) => q.hour === t.time_id) || null;
            timeStatuses[t.time_id] = qcForHour
              ? {
                  status: qcForHour.tls_status ?? "",
                  defects: qcForHour.defects ?? [],
                  tot_defects: qcForHour.tot_defects ?? "",
                }
              : {
                  // Use master status if no QC data for this time slot
                  status: item.tls_master_status || "",
                  defects: [],
                  tot_defects: "0",
                };
          });

          return {
            no: idx + 1,
            tls_op_name: item.tls_operation?.tls_op_name ?? "",
            staff_user: {
              full_name: item.staff_user?.full_name ?? "",
              username: item.staff_user?.username ?? "",
            },
            timeStatuses,
            start_time: item.start_time || "",
            hasQcData: qcData.length > 0,
            batch_id: item.batch_id ?? "",
            tls_master_status: item.tls_master_status || "", // Include master status
          };
        });

        setTableData(rows);
        setFilteredTableData(rows);
      } else {
        setTableData([]);
        setFilteredTableData([]);
      }
    } catch (err) {
      console.error("loadTlsBoard", err);
      setTableData([]);
      setFilteredTableData([]);
    } finally {
      setLoading(false);
    }
  }

  // Search filter
  useEffect(() => {
    if (!searchQuery) {
      setFilteredTableData(tableData);
      return;
    }
    const q = searchQuery.toLowerCase();
    const filtered = tableData.filter((r) => {
      const op = `${r.staff_user?.full_name || ""} ${r.staff_user?.username || ""}`.toLowerCase();
      const opName = (r.tls_op_name || "").toLowerCase();
      return op.includes(q) || opName.includes(q);
    });
    setFilteredTableData(filtered);
  }, [searchQuery, tableData]);

  // Build table header times
  const timeHeaders = useMemo(() => 
    timeSettings.map((t) => ({ 
      id: t.time_id, 
      label: t.time_id,
      timeRange: `${(t.start_time||"").slice(0,5)}-${(t.end_time||"").slice(0,5)}`
    })), 
    [timeSettings]
  );

  // Status color mapping
  const statusToColor = (status) => {
    if (!status) return colors.textLight; // gray for no data
    if (status === "yellow") return colors.warning;
    if (status === "red") return colors.danger;
    if (status === "blue") return colors.primary;
    if (status === "green") return colors.success;
    return colors.textLight;
  };

  const openDefectModal = (title, defects) => {
    setDefectModal({ visible: true, title, defects: defects || [] });
  };
  const closeDefectModal = () => setDefectModal({ visible: false, title: "", defects: [] });

  // Custom styles
  const containerStyle = {
    background: colors.background,
    minHeight: "100vh",
    padding: "24px",
  };

  const cardStyle = {
    background: colors.surface,
    borderRadius: "12px",
    padding: "24px",
    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    border: `1px solid ${colors.border}`,
  };

  const infoCardStyle = {
    background: `linear-gradient(135deg, ${colors.primary}08, ${colors.primary}03)`,
    border: `1px solid ${colors.primary}15`,
    borderRadius: "8px",
    padding: "16px",
  };

  const thStyle = {
    padding: "16px 12px",
    textAlign: "center",
    background: colors.background,
    color: colors.text,
    fontWeight: "600",
    fontSize: "13px",
    borderBottom: `2px solid ${colors.border}`,
    whiteSpace: "nowrap",
    minWidth: "120px",
  };

  const tdStyle = {
    padding: "16px 12px",
    borderBottom: `1px solid ${colors.border}`,
    color: colors.text,
    fontSize: "14px",
  };

  const tdStyleCenter = { 
    ...tdStyle, 
    textAlign: "center",
    minWidth: "120px",
  };

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        {/* Header Section */}
        <div style={{ marginBottom: "32px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "8px" }}>
            <div style={{
              width: "4px",
              height: "32px",
              background: colors.primary,
              borderRadius: "2px"
            }}></div>
            <Title level={2} style={{ margin: 0, color: colors.text }}>
              TLS Board
            </Title>
          </div>
          <Text style={{ color: colors.textLight, fontSize: "16px" }}>
            Track operator performance and quality status across time slots
          </Text>
        </div>

        {/* Filters Section */}
        <Card 
          style={{ 
            ...cardStyle, 
            marginBottom: "20px",
            background: `linear-gradient(135deg, ${colors.primary}02, ${colors.primary}05)`
          }}
          bodyStyle={{ padding: "20px" }}
        >
          <Row gutter={[20, 16]}>
            <Col xs={24} md={8}>
              <Text strong style={{ display: "block", marginBottom: "8px", color: colors.text }}>
                <UserOutlined style={{ marginRight: "8px", color: colors.primary }} />
                Production Line
              </Text>
              <Select
                placeholder="Select Line"
                value={selectedLine || undefined}
                onChange={onLineChange}
                allowClear
                style={{ width: "100%" }}
                loading={loading && !lines.length}
                size="large"
                suffixIcon={<UserOutlined style={{ color: colors.primary }} />}
              >
                {lines.map((l, idx) => (
                  <Option key={idx} value={l}>
                    {l}
                  </Option>
                ))}
              </Select>
            </Col>

            <Col xs={24} md={8}>
              <Text strong style={{ display: "block", marginBottom: "8px", color: colors.text }}>
                <BarcodeOutlined style={{ marginRight: "8px", color: colors.primary }} />
                Item Number
              </Text>
              <Select
                placeholder="Select Item"
                value={selectedItem || undefined}
                onChange={onItemChange}
                allowClear
                style={{ width: "100%" }}
                disabled={!selectedLine}
                size="large"
                suffixIcon={<BarcodeOutlined style={{ color: colors.primary }} />}
              >
                {items.map((it, idx) => (
                  <Option key={idx} value={it.item_no}>
                    {it.item_no} {it.batch_status ? `(${it.batch_status})` : ""}
                  </Option>
                ))}
              </Select>
            </Col>

            <Col xs={24} md={8}>
              <Text strong style={{ display: "block", marginBottom: "8px", color: colors.text }}>
                <CalendarOutlined style={{ marginRight: "8px", color: colors.primary }} />
                Select Date
              </Text>
              <DatePicker
                style={{ width: "100%" }}
                format="DD-MM-YYYY"
                value={selectedDate}
                onChange={onDateChange}
                disabled={!selectedItem}
                allowClear={false}
                size="large"
                suffixIcon={<CalendarOutlined style={{ color: colors.primary }} />}
              />
            </Col>
          </Row>
        </Card>

        {/* Information Cards */}
        {(selectedLine && selectedItem) && (
          <div style={{ ...infoCardStyle, marginBottom: "20px" }}>
            <Row gutter={[20, 16]} align="middle">
              <Col xs={24} sm={6}>
                <div style={{ textAlign: "center" }}>
                  <div style={{ fontSize: "12px", color: colors.textLight, fontWeight: "600", marginBottom: "4px" }}>
                    <ClockCircleOutlined style={{ marginRight: "4px" }} />
                    CURRENT HOUR
                  </div>
                  <div style={{ 
                    fontSize: "18px", 
                    color: colors.primary, 
                    fontWeight: "700",
                    background: `${colors.primary}10`,
                    padding: "8px 12px",
                    borderRadius: "6px"
                  }}>
                    {currentTimeId || "-"}
                  </div>
                </div>
              </Col>
              <Col xs={24} sm={6}>
                <div style={{ textAlign: "center" }}>
                  <div style={{ fontSize: "12px", color: colors.textLight, fontWeight: "600", marginBottom: "4px" }}>
                    <CalendarOutlined style={{ marginRight: "4px" }} />
                    SELECTED DATE
                  </div>
                  <div style={{ 
                    fontSize: "18px", 
                    color: colors.text, 
                    fontWeight: "700",
                    background: `${colors.success}10`,
                    padding: "8px 12px",
                    borderRadius: "6px"
                  }}>
                    {selectedDate ? selectedDate.format("DD/MM/YYYY") : "-"}
                  </div>
                </div>
              </Col>
              <Col xs={24} sm={6}>
                <div style={{ textAlign: "center" }}>
                  <div style={{ fontSize: "12px", color: colors.textLight, fontWeight: "600", marginBottom: "4px" }}>
                    <HighlightOutlined style={{ marginRight: "4px" }} />
                    COLOR
                  </div>
                  <div style={{ 
                    fontSize: "18px", 
                    color: colors.text, 
                    fontWeight: "700",
                    background: `${colors.warning}10`,
                    padding: "8px 12px",
                    borderRadius: "6px"
                  }}>
                    {color}
                  </div>
                </div>
              </Col>
              <Col xs={24} sm={6}>
                <div style={{ textAlign: "center" }}>
                  <div style={{ fontSize: "12px", color: colors.textLight, fontWeight: "600", marginBottom: "4px" }}>
                    <BarcodeOutlined style={{ marginRight: "4px" }} />
                    STYLE NUMBER
                  </div>
                  <div style={{ 
                    fontSize: "18px", 
                    color: colors.text, 
                    fontWeight: "700",
                    background: `${colors.secondary}10`,
                    padding: "8px 12px",
                    borderRadius: "6px"
                  }}>
                    {styleNo}
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        )}

        {/* Search and Table Section */}
        <Card style={cardStyle} bodyStyle={{ padding: 0 }}>
          {/* Search Header */}
          <div style={{ 
            padding: "20px 24px", 
            borderBottom: `1px solid ${colors.border}`,
            display: "flex", 
            justifyContent: "space-between", 
            alignItems: "center",
            background: colors.background
          }}>
            <Text strong style={{ fontSize: "16px", color: colors.text }}>
              Operator Performance Data
            </Text>
            <Input
              placeholder="Search operator or operation..."
              prefix={<SearchOutlined style={{ color: colors.textLight }} />}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              style={{ width: 300 }}
              allowClear
            />
          </div>

          {/* Table with Horizontal Scroll */}
          <Spin spinning={loading} size="large">
            {!filteredTableData.length || timeSettings.length === 0 ? (
              <div style={{ padding: "60px 20px" }}>
                {timeSettings.length === 0 ? (
                  <Empty 
                    description="Loading time settings..."
                    imageStyle={{ height: 80 }}
                  />
                ) : (
                  <Empty 
                    description={
                      selectedDate ? "No operator data for selected filters" : "Select Line, Item and Date to load data"
                    }
                    imageStyle={{ height: 80 }}
                  />
                )}
              </div>
            ) : (
              <div style={{ 
                overflowX: "auto",
                width: "100%"
              }}>
                <table style={{ 
                  width: "100%", 
                  borderCollapse: "collapse",
                  minWidth: "800px"
                }}>
                  <thead>
                    <tr>
                      <th style={{ ...thStyle, width: "60px", minWidth: "60px" }}>#</th>
                      <th style={{ ...thStyle, textAlign: "left", width: "200px", minWidth: "200px" }}>Operator</th>
                      <th style={{ ...thStyle, textAlign: "left", width: "250px", minWidth: "250px" }}>Operation Name</th>
                      {timeHeaders.map((t) => (
                        <th key={t.id} style={thStyle}>
                          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <Text strong style={{ fontSize: "14px", color: colors.primary }}>
                              {t.label}
                            </Text>
                            <Text style={{ fontSize: "11px", color: colors.textLight, marginTop: "2px" }}>
                              {t.timeRange}
                            </Text>
                          </div>
                        </th>
                      ))}
                    </tr>
                  </thead>

                  <tbody>
                    {filteredTableData.map((row, idx) => (
                      <tr key={idx} style={{ 
                        borderBottom: `1px solid ${colors.border}`,
                        background: idx % 2 === 0 ? colors.surface : `${colors.background}50`,
                      }}>
                        <td style={{ ...tdStyleCenter, width: "60px" }}>{row.no}</td>
                        <td style={{ ...tdStyle, width: "200px" }}>
                          <div>
                            <Text strong style={{ display: "block", color: colors.text }}>
                              {row.staff_user?.full_name}
                            </Text>
                            <Text type="secondary" style={{ fontSize: "12px" }}>
                              {row.staff_user?.username}
                            </Text>
                          </div>
                        </td>
                        <td style={{ ...tdStyle, width: "250px" }}>
                          <Text style={{ color: colors.text }}>
                            {row.tls_op_name}
                          </Text>
                        </td>

                        {timeHeaders.map((t) => {
                          const ts = row.timeStatuses?.[t.id] || {};
                          const empty = !ts || Object.keys(ts).length === 0;
                          
                          if (empty) {
                            return (
                              <td key={t.id} style={tdStyleCenter}>
                                <div
                                  style={{
                                    width: "36px",
                                    height: "36px",
                                    margin: "auto",
                                    borderRadius: "50%",
                                    background: colors.textLight,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    border: `2px solid ${colors.border}`,
                                    opacity: 0.3,
                                  }}
                                  title="No data"
                                >
                                  <div style={{ 
                                    width: "16px", 
                                    height: "16px", 
                                    borderRadius: "50%", 
                                    background: "#fff",
                                  }} />
                                </div>
                              </td>
                            );
                          }

                          const statusColor = statusToColor(ts.status);
                          const hasDefects = Array.isArray(ts.defects) && ts.defects.length > 0;

                          return (
                            <td key={t.id} style={tdStyleCenter}>
                              <div
                                role="button"
                                onClick={() => {
                                  if (hasDefects) {
                                    openDefectModal(
                                      `Defects - ${row.staff_user?.full_name} - ${t.id} (${t.timeRange})`, 
                                      ts.defects
                                    );
                                  }
                                }}
                                style={{
                                  width: "36px",
                                  height: "36px",
                                  margin: "auto",
                                  borderRadius: "50%",
                                  background: statusColor,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  cursor: hasDefects ? "pointer" : "default",
                                  border: `2px solid ${colors.border}`,
                                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                  transition: "all 0.2s ease",
                                }}
                                onMouseEnter={(e) => {
                                  if (hasDefects) {
                                    e.target.style.transform = "scale(1.1)";
                                    e.target.style.boxShadow = "0 4px 8px rgba(0,0,0,0.2)";
                                  }
                                }}
                                onMouseLeave={(e) => {
                                  if (hasDefects) {
                                    e.target.style.transform = "scale(1)";
                                    e.target.style.boxShadow = "0 2px 4px rgba(0,0,0,0.1)";
                                  }
                                }}
                                title={`Status: ${ts.status || 'No data'}${hasDefects ? ` (Defects: ${ts.tot_defects})` : ''}`}
                              >
                                <div style={{ 
                                  width: "16px", 
                                  height: "16px", 
                                  borderRadius: "50%", 
                                  background: "#fff",
                                  boxShadow: "0 1px 2px rgba(0,0,0,0.1)"
                                }} />
                              </div>
                            </td>
                          );
                        })}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </Spin>
        </Card>
      </div>

      {/* Defect Details Modal */}
      <Modal
        open={defectModal.visible}
        title={
          <div>
            <Text strong style={{ color: colors.primary, fontSize: "16px" }}>
              {defectModal.title}
            </Text>
          </div>
        }
        onCancel={closeDefectModal}
        footer={[
          <Button 
            key="close" 
            onClick={closeDefectModal}
            type="primary"
            style={{ background: colors.primary, borderColor: colors.primary }}
          >
            Close
          </Button>,
        ]}
        width={600}
      >
        {Array.isArray(defectModal.defects) && defectModal.defects.length ? (
          <div style={{ maxHeight: "400px", overflowY: "auto" }}>
            {defectModal.defects.map((d, i) => (
              <Card 
                key={i} 
                size="small" 
                style={{ 
                  marginBottom: "12px",
                  border: `1px solid ${colors.border}`,
                  background: `${colors.background}50`
                }}
                bodyStyle={{ padding: "16px" }}
              >
                <Space direction="vertical" style={{ width: "100%" }} size="small">
                  <div>
                    <Text strong style={{ color: colors.text }}>Defect Reason: </Text>
                    <Text style={{ color: colors.text }}>{d.reason || "Not specified"}</Text>
                  </div>
                  <Divider style={{ margin: "8px 0", background: colors.border }} />
                  <div>
                    <Text type="secondary">Defect Code: </Text>
                    <Tag color={colors.primary} style={{ marginLeft: "8px" }}>
                      {d.def_code || "N/A"}
                    </Tag>
                  </div>
                </Space>
              </Card>
            ))}
          </div>
        ) : (
          <Empty description="No defects recorded for this time slot" />
        )}
      </Modal>
    </div>
  );
}